/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var imageViewerDefaultProps = {
  closeBtn: true,
  draggable: void 0,
  images: [],
  mode: "modal",
  showOverlay: void 0,
  defaultVisible: false,
  defaultIndex: 0
};

export { imageViewerDefaultProps };
//# sourceMappingURL=defaultProps.js.map
